import React from 'react'
import { ISettingsService } from '../../core/response.types'

interface Props {
  services: ISettingsService[]
  value: string
  disabled: boolean
  onChange: (code: string) => void
}

export default function ServiceSelector({ services, value, disabled, onChange }: Props) {
  return (
    <div className='d-flex align-items-center gap-3'>
      <label className='fw-semibold text-gray-700'>Сервис:</label>
      <select
        className='form-select form-select-sm w-auto'
        style={{ minWidth: 220 }}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        {services.map((s) => (
          <option key={s.code} value={s.code}>
            {s.label}
          </option>
        ))}
      </select>
      {disabled && <span className='spinner-border spinner-border-sm text-primary' />}
    </div>
  )
}
